import { anonymousStackKey, assistanceKey, assistanceStackKey, dashboardKey, dashboardStackKey, genericKey, instantHelpStackKey, libraryStackKey, organizationAssistanceKey, pathKey, phoneKey, privateKey, publicKey, reckoningResultKey, thankYouKey, videocallKey } from '../../constants/routeKeys';
import { concatPath } from './concatPath';
import { registerKey } from '../../constants/routeKeys';
import { router } from 'expo-router';

export const goTo = {
  register: (order = 2) => {
    router.navigate(concatPath([publicKey, registerKey], order));
  },
  thankYou: (order = -1) => {
    router.navigate(concatPath([anonymousStackKey, thankYouKey], order));
  },
  dashboard: (order = -1) => {
    router.navigate(concatPath([privateKey, dashboardStackKey, dashboardKey], order));
  },
  assistanceOwn: (order = -1) => {
    router.navigate(concatPath([privateKey, assistanceStackKey, organizationAssistanceKey], order));
  },
  assistance: (order = -1) => {
    router.navigate(concatPath([ privateKey, assistanceStackKey, assistanceKey], order));
  },
  library: () => {
    router.navigate({
      pathname: concatPath([ privateKey, libraryStackKey], -1) as string,
    });
  },
  instantHelp: (screenKey: typeof videocallKey | typeof phoneKey, params: Record<string, string>) => {
    router.navigate({
      pathname: concatPath([privateKey, assistanceStackKey, instantHelpStackKey, screenKey], -1) as string,
      params
    });
  },
  path: (pathId: string, order = -1) => {
    router.navigate({
      pathname: concatPath([ privateKey, libraryStackKey, pathKey], order) as string,
      params : {
        id: pathId as string
      }
    });
  },
  genericPage: (id: string, order = -1) => {
    router.navigate({
      pathname: concatPath([privateKey, libraryStackKey, genericKey ], order) as string,
      params : {
        id,
      }
    });
  },
  reckoningResult: (featureId: string, strategyId: string, inPrivate = true, order = -1) => {
    const mainKey = inPrivate ? privateKey : anonymousStackKey;
    router.navigate({
      pathname: concatPath([mainKey, dashboardStackKey, reckoningResultKey], order) as string,
      params: {
        featureId,
        strategyId
      }
    });
  }
};
